export const COM = 'COM %';
export const AER = 'AER';
export const HIGHEST_RATIO = 'The highest ratio';
export const LOWEST_RATIO = 'The lowest ratio';
